import React from 'react';
import { Link } from "react-router-dom"

// import features data
import { featuresData } from '../data';

// import icons
import { BsArrowRight } from 'react-icons/bs';

const Features = () => {
  // destructure features data
  const { title, subtitle,image1,image2,image3,image4,bgImage1,bgImage2,bgImage3,bgImage4 } = featuresData;
  return (
    <section id='fitur' className='bg-accent-primary py-[70px] my-[70px] xl:my-[150px]'>
      <div className='container mx-auto'>
        {/* text */}
        <div className='text-center'>
          <h2
            className='h2 mb-6 xl:mb-12'
            data-aos='fade-down'
            data-aos-delay='100'
          >
            {title}
          </h2>
          <p
            className='lead max-w-[584px] mx-auto mb-16 xl:mb-24 text-primary'
            data-aos='fade-down'
            data-aos-delay='200'
          >
            Ini adalah beberapa fitur yang tersedia di Islamic Learning
          </p>
        </div>
        {/* feature list */}
        <div className='grid grid-cols-1 gap-[50px] xl:grid-cols-2'>
              <div
                className='w-full max-w-[530px] h-[358px] relative flex flex-col items-center justify-center xl:flex-row xl:justify-start mx-auto'
                data-aos='zoom-in'
                data-aos-offset='100'
                data-aos-delay="400"
              >
                {/* bg image */}
                <div className='hidden xl:flex absolute top-0 right-0 -z-10'>
                  <img src={bgImage1} />
                </div>

                {/* icon image */}
                <div
                  className='max-w-[120px] xl:mr-7 xl:max-w-[232px]'
                  data-aos='zoom-in-right'
                  data-aos-delay="400"
                >
                  <img src={image1} />
                </div>
                {/* text */}
                <div className='max-w-[220px]'>
                  <h3 className='h3 mb-4'>Doa Harian</h3>
                  <p className='font-light italic mb-4 text-primary'>Mengamalkan doa harian adalah bentuk syukur atas karunia yang telah Allah Swt berikan. Semestinya tidak ada alasan untuk tidak membiasakan amalan yang baik ini.</p>
                  {/* link & arrow */}
                  <div className='flex items-center gap-x-2 group'>
                    
                <Link to="/doa">
                    <a className='text-primary font-bold' href='#'>
                      Learn More
                    </a>
                   </Link>
                    <BsArrowRight className='text-xl text-accent-secondary group-hover:ml-[5px] transition-all' />
                  </div>
                </div>
              </div>
              {/* fitur 2 */}
              <div
                className='w-full max-w-[530px] h-[358px] relative flex flex-col items-center justify-center xl:flex-row xl:justify-start mx-auto'
                data-aos='zoom-in'
                data-aos-offset='100'
                data-aos-delay="700"
              >
                {/* bg image */}
                <div className='hidden xl:flex absolute top-0 right-0 -z-10'>
                  <img src={bgImage2} />
                </div>

                {/* icon image */}
                <div
                  className='max-w-[120px] xl:mr-7 xl:max-w-[232px]'
                  data-aos='zoom-in-right'
                  data-aos-delay="700"
                >
                  <img src={image2} />
                </div>
                {/* text */}
                <div className='max-w-[220px]'>
                  <h3 className='h3 mb-4'>Kisah 25 Nabi</h3>
                  <p className='font-light italic mb-4 text-primary'>Kumpulan kisah dan cerita cerita lengkap 25 nabi dan rasul yang dikemas dalam narasi yang menarik dan enak untuk dinikmati.</p>
                  {/* link & arrow */}
                  <div className='flex items-center gap-x-2 group'>
                    
                <Link to="/nabi">
                    <a className='text-primary font-bold' href='#'>
                      Learn More
                    </a>
                   </Link>
                    <BsArrowRight className='text-xl text-accent-secondary group-hover:ml-[5px] transition-all' />
                  </div>
                </div>
              </div>
              {/* fitur 3 */}
              <div
                className='w-full max-w-[530px] h-[358px] relative flex flex-col items-center justify-center xl:flex-row xl:justify-start mx-auto'
                data-aos='zoom-in'
                data-aos-offset='100'
                data-aos-delay="1000"
              >
                {/* bg image */}
                <div className='hidden xl:flex absolute top-0 right-0 -z-10'>
                  <img src={bgImage3} />
                </div>

                {/* icon image */}
                <div
                  className='max-w-[120px] xl:mr-7 xl:max-w-[232px]'
                  data-aos='zoom-in-right'
                  data-aos-delay="1000"
                >
                  <img src={image3} />
                </div>
                {/* text */}
                <div className='max-w-[220px]'>
                  <h3 className='h3 mb-4'>Asmaul Husna</h3>
                  <p className='font-light italic mb-4 text-primary'>Berikut ini adalah 99 Asmaul Husna atau nama-nama baik Allah swt disertai dengan arti dan maknanya. Dijelaskan juga dalil serta hikmah dari Asmaul Husna.</p>
                  {/* link & arrow */}
                  <div className='flex items-center gap-x-2 group'>
                    
                <Link to="/asmaul">
                    <a className='text-primary font-bold' href='#'>
                      Learn More
                    </a>
                   </Link>
                    <BsArrowRight className='text-xl text-accent-secondary group-hover:ml-[5px] transition-all' />
                  </div>
                </div>
              </div>
              {/* fitur 4 */}
              <div
                className='w-full max-w-[530px] h-[358px] relative flex flex-col items-center justify-center xl:flex-row xl:justify-start mx-auto'
                data-aos='zoom-in'
                data-aos-offset='100'
                data-aos-delay="1300"
              >
                {/* bg image */}
                <div className='hidden xl:flex absolute top-0 right-0 -z-10'>
                  <img src={bgImage4} />
                </div>

                {/* icon image */}
                <div
                  className='max-w-[120px] xl:mr-7 xl:max-w-[232px]'
                  data-aos='zoom-in-right'
                  data-aos-delay="1300"
                >
                  <img src={image4} />
                </div>
                {/* text */}
                <div className='max-w-[220px]'>
                  <h3 className='h3 mb-4'>Video Interaktif</h3>
                  <p className='font-light italic mb-4 text-primary'>Media Pembelajaran Interaktif Pendidikan Agama Islam dengan animasi yang fun dan edukatif</p>
                  {/* link & arrow */}
                  <div className='flex items-center gap-x-2 group'>
                    
                <Link to="/video">
                    <a className='text-primary font-bold' href='#'>
                      Learn More
                    </a>
                   </Link>
                    <BsArrowRight className='text-xl text-accent-secondary group-hover:ml-[5px] transition-all' />
                  </div>
                </div>
              </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
